import { getBenchmarkColor } from '../components/benchmarks';
import { ChartContext } from '../interface';
import { convertDateStringToUTC } from './helper';

export function createProfitSeries(
  series: ChartContext.IAssetQuotes[]
): Highcharts.SeriesOptionsType[] {
  return series.map(({ quotes, ...item }) => ({
    ...item,
    name: item?.shortname || item.name || item?.nicename,
    data: quotes?.map(({ d, c, q }) => [convertDateStringToUTC(d), c || q]),
    color: item.color,
    lineWidth: 2,
    type: item?.type || ('line' as any),
  }));
}

export function createBenchmarksProfitSeries(
  series: Omit<ChartContext.IAssetQuotes, 'color'>[]
): Highcharts.SeriesOptionsType[] {
  return createProfitSeries(series as any).map((item) => {
    return {
      ...item,
      color: getBenchmarkColor(item.name),
      opacity: 0.4,
      lineWidth: 1.5,
    };
  });
}
